import React, { useEffect, useRef, useState } from "react";
import styles from "./../../styles/resultrowanalytics.module.css";
import { AthleteDTO } from "../../../../interfaces/AthletesDTO";
import { RaceDTO } from "../../../../interfaces/RaceDTO";
import { GetTopResults, TimeDiffDTO } from "../../../../services/resultWorker";
import ResultRowAnalyticsPass from "./ResultRowAnalyticsPass";
import { useResultTable } from "../../../../services/ResultTableProvider";

interface Props {
  race: RaceDTO | null;
  athlete: AthleteDTO | null;
  ipos: number | null;
}

const ResultRowAnalytics = ({ athlete, ipos, race }: Props) => {
  const runtTimeRef = useRef<number | null>(null);
  const [currentTime, setCurrentTime] = useState<(TimeDiffDTO | null)[]>([]);
  const [beforeTime, setBeforeTime] = useState<(TimeDiffDTO | null)[]>([]);
  const {getAnalytic} = useResultTable();
  useEffect(() => {
    if (athlete) {
      let cur = "";
      let bef = "";
      if (ipos && athlete && race) {
        if (ipos in athlete.Times) {
          let timDif = GetTopResults(
            race.Class[athlete.ClassID].Level[athlete.Level].TimePos[ipos]
              .TimePass,
            athlete,
            ipos
          );
          setCurrentTime(timDif);
        }
          
          updateTimes(false);
      }
      const startInterval = () => {
        if (runtTimeRef.current !== null) return;
        runtTimeRef.current = window.setInterval(() => {
          updateInterval();
        }, 1000);
      };
      startInterval();
    }
    return () => {
      if (runtTimeRef.current !== null) {
        window.clearInterval(runtTimeRef.current);
        runtTimeRef.current = null;
      }
    };
  }, []);

  const updateInterval = () => {
    updateTimes(true);
  };
  const updateTimes = (isInterval:boolean) => {
    if (!ipos || !athlete || !race ) {
        return;
      }
      if ( !getAnalytic(athlete.ID) &&  isInterval ){
        return;
      }
      let befIpos = Math.max(
        ...Object.keys(
          race.Class[athlete.ClassID].Level[athlete.Level].TimePos
        )
          .map((o) => parseInt(o))
          .filter((o) => o < 999)
      );
      if (ipos !== 999){
        befIpos = ipos - 1;
      }
      
      
      if (ipos in athlete.Times) {
        let timDif = GetTopResults(
          race.Class[athlete.ClassID].Level[athlete.Level].TimePos[ipos].TimePass,
          athlete,
          ipos
        );
        setCurrentTime(timDif);
      }
      if (befIpos in athlete.Times) {
        let timDif = GetTopResults(
          race.Class[athlete.ClassID].Level[athlete.Level].TimePos[befIpos]
            .TimePass,
          athlete,
          befIpos
        );
        setBeforeTime(timDif);
      }
  }

  return (
    <table className={styles.resultRowAnalytics}>
        <tbody>
      <tr
        className={`${styles.resultRowAnalyticsRow} ${styles.resultRowAnalyticsTopRow}`}
      >
        {currentTime
          ? currentTime.map((obj) => {
              return obj ? (
                <ResultRowAnalyticsPass
                  key={"cur_" + obj.rnk}
                  diffData={obj}
                  isFirstRow={true}
                />
              ) : (
                ""
              );
            })
          : ""}
      </tr>
      <tr className={styles.resultRowAnalyticsSplitTime}>
        {beforeTime
          ? beforeTime.map((obj) => {
              return obj ? (
                <ResultRowAnalyticsPass
                  key={"bef_" + obj.rnk}
                  diffData={obj}
                  isFirstRow={false}
                />
              ) : (
                ""
              );
            })
          : ""}
      </tr>
      </tbody>
    </table>
  );
};

export default ResultRowAnalytics;
